export default __webpack_public_path__ + "static/media/ic_report_builder.ccd447f9.svg";